import { computed, inject } from '@angular/core';
import { toSignal } from '@angular/core/rxjs-interop';
import { TranslateService } from '@tolgee/ngx';

export function languageComputed<T>(fn: (language?: string) => T) {
  const translate = inject(TranslateService);
  const lang = toSignal(translate.languageAsync);
  return computed<T>(() => {
    const language = lang();
    return fn(language);
  });
}
